export default function UscisSection() {
    return (
        <section className="py-[40px]">
            <div className="container flex justify-between items-center">
                <div className="w-[48%]">
                    <img className="w-[65%] h-full" src={require("../../assets/images/USCIS.jpg")} alt="" />
                </div>
                <div className="w-[48%]">
                    <div className="text-[40px] text-[#2563eb]">USCIS will approve your petition...</div>
                    <p>
                        Real immigration attorneys designed our system to make sure your petition is 100% correct. You avoid typical I-751 rejection and denial rates. Using our system, we guarantee USCIS will approve your petition.
                    </p>
                </div>
            </div>
        </section>
    );
}